import { Card, Empty, Space } from "antd";
import { useTranslation } from "react-i18next"

export default function CustomerInformation({ data }) {
   const { t } = useTranslation();
   return (
      <Card title={t('ordersReturn.customerInformation')} className="text-text-dark-gray">
         {data ? (
            <Space direction="vertical" size={5}>
               <div className="font-semibold">{`${data?.firstName || ''} ${data?.lastName || ''}`}</div>
               <div className="opacity-50">{data?.email || ''}</div>
               <div className="opacity-50">{data?.telephone || ''}</div>
            </Space>
         ) : <Empty />}
      </Card>
   )
}